import type { IconSvgObject } from './types';

const EllipseIcon: IconSvgObject = [
  ["ellipse", { cx: "12", cy: "12", rx: "10", ry: "7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default EllipseIcon;
